import * as React from 'react';
import { Font, Palette, ThemeConfiguration } from 'mm-theme-configuration/dist/interfaces';
import { ThemeManager } from './themeManager';
import {
  ActualTypographySizesFontFamiliesMap,
  createTypographySizesFontFamiliesMap, defaultWebFontsContext,
  translateFontSizes,
  TypographySizesFontFamiliesMap,
} from './fontSizeTranslator';

interface ThemeProviderWithFontsProps {
  palette: Palette;
  themeConfiguration: ThemeConfiguration;
}

export interface WebFontsComponentProps {
  typographySizesFontFamiliesMap: TypographySizesFontFamiliesMap;
  fontsConfiguration: Font[];
}

export type ThemeContext = { [key: string]: any };
export const ThemeContext: React.Context<ThemeContext> = React.createContext({});
type WebFontsContext = ActualTypographySizesFontFamiliesMap;
export const WebFontsContext: React.Context<WebFontsContext> = React.createContext(defaultWebFontsContext);

interface ThemeProps {
  configuration: { [key: string]: any };
}
const Theme: React.FunctionComponent<ThemeProps> = ({ configuration, children }) => {
  const actualTypographySizesFontFamiliesMap = React.useContext(WebFontsContext);
  const fontSizesStyles = translateFontSizes(configuration.fontSizeMap, actualTypographySizesFontFamiliesMap);
  const themeContext = {
    ...configuration,
    fontSizesStyles,
  };
  return (
    <ThemeContext.Provider value={themeContext}>
      {children}
    </ThemeContext.Provider>
  );
};
export const ThemeProviderWithFonts = (WebFontsComponent: React.FunctionComponent<WebFontsComponentProps>) => {
  const ThemeProviderWithFontsComponent: React.FunctionComponent<ThemeProviderWithFontsProps> = props => {
    const { palette, themeConfiguration, children } = props;
    const themeManager = new ThemeManager(palette, themeConfiguration);
    const configuration = themeManager.getConfiguration();
    const typographySizesFontFamiliesMap = createTypographySizesFontFamiliesMap(themeManager.paletteManager.getFontSizeMap());
    const fontsConfiguration = themeManager.paletteManager.getFonts();

    return (
      <WebFontsComponent typographySizesFontFamiliesMap={typographySizesFontFamiliesMap} fontsConfiguration={fontsConfiguration}>
        <Theme configuration={configuration}>
          {children}
        </Theme>
      </WebFontsComponent>
    );
  };
  return ThemeProviderWithFontsComponent;
};
